import { Card, Flex, Typography } from "antd";
import { MailOutlined, InstagramOutlined } from "@ant-design/icons";
import pokemoneda from "../../../Assets/pokemoneda.png";
import { AvatarPerfil } from "./style";
import { useWonderCoins } from "../../../Hooks/Player";
import { useEffect } from "react";


const { Title } = Typography;

export const DatosEntrenador = () => {
  const storedDataUser = JSON.parse(localStorage.getItem('dataUser'));

  const { data, isFetching: cargandoData } = useWonderCoins();
  
  return (
    <Card
      hoverable
      style={{
        width: "90vw",
        backgroundColor: "rgba(255, 255, 255, 0)",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.8)",
        border: "none",
      }}
      styles={{
        body: { padding: 0, overflow: "hidden", borderRadius: "0.5rem" },
      }}
    >
      <Flex justify="center">
        <AvatarPerfil src={storedDataUser.imag_url} />

        <Flex
          vertical
          style={{
            padding: 10,
            width: "60%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          }}
        >
          <Title level={5} style={{ color: "#FFFF" }}>
          {storedDataUser.usua_nombre}
          </Title>
          <Flex style={{ alignItems: "center" }} gap="0.5rem">
            <MailOutlined style={{ color: "#FFFF" }} />
            <span style={{ color: "#FFFF" }}>{storedDataUser.usua_correo}</span>
          </Flex>

          <Flex style={{ alignItems: "center" }} gap="0.5rem">
            <InstagramOutlined style={{ color: "#FFFF" }} />
            <span style={{ color: "#FFFF" }}>{storedDataUser.usua_ig}</span>
          </Flex>

          <Flex style={{ alignItems: "center" }} gap="0.5rem">
            <img
              alt="pokemoneda"
              src={pokemoneda}
              style={{
                width: "20px",
                height: "auto",
              }}
            />
            <span style={{ color: "#FFFF" }}>{!cargandoData ? data : "..."}</span>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};
